<template>
  <div>
    <slot name="title" :requiredPhotos="requiredPhotos">
      <p class="text-base pt-2 pb-5">
        Tap the {{ requiredPhotos ? "buttons" : "button" }} below to add
        photos...
      </p>
    </slot>
    <template v-if="requiredPhotos">
      <div
        v-for="photo in specificPhotos"
        :key="photo.id"
        class="rounded border-2 p-2 my-2 text-center"
        :class="
          isValidRequiredPhotos || photo.images.length
            ? 'border-neutral-700'
            : 'border-red-600'
        "
      >
        <div
          class="fileContainer text-center bg-opacity-50 bg-white border-2 border-gray-400"
        >
          <div class="text-gray-700 text-sm py-1">
            + Add {{ photo.option }} photo(s)
          </div>
          <input
            :ref="`imageUploadInput${photo.id}`"
            class="align-middle button required"
            type="file"
            multiple
            :capture="typeCapture"
            @change="handleAddNewSpecificPhotos($event, photo.id, photo.option)"
          />
        </div>

        <div
          v-if="photo.images.length"
          class="container mt-4 flex justify-center"
        >
          <div
            v-for="(image, index) in photo.images"
            :key="image.id"
            class="mb-2 p-2"
          >
            <div class="relative">
              <slot name="specific" :index="index" :image="image" :photoId="photo.id">
                <el-image
                  v-if="image.url && image.fileType != 'image/heif'" 
                  :id="'img' + index"
                  :src="image.url"
                  class="h-36 w-full object-cover rounded-lg"
                >
                  <div slot="error" class="image-slot">
                    <div class="h-36 w-20 flex items-center justify-center bg-gray-200 rounded-lg">
                      <i class="uil uil-image text-gray-400 text-4xl"></i>
                    </div>
                  </div>
                </el-image>

              </slot>
            </div>
          </div>
        </div>
        <div v-else>
          <p
            class="text-center"
            :class="{ 'text-red-600': !isValidRequiredPhotos }"
          >
            No photos added.
          </p>
        </div>
      </div>
      <div class="rounded border-2 p-2 my-2 border-neutral-700 text-center">
        <div
          class="fileContainer bg-opacity-50 bg-white border-2 border-gray-400"
        >
          <div class="text-gray-700 text-sm py-1">
            + Add other photos (optional)
          </div>
          <input
            ref="imageOptionalUploadInput"
            class="align-middle"
            type="file"
            multiple
            :capture="typeCapture"
            @change="handleOptionalImages"
          />
        </div>
        <div
          v-if="optionalPhotos.length > 0"
          class="container mt-4 flex justify-center"
        >
          <div
            v-for="(image, index) of optionalPhotos"
            :key="image.id"
            class="mb-2 p-2"
          >
            <div class="relative">
              <slot name="optional" :index="index" :image="image">
                <el-image
                  v-if="image.url && image.fileType != 'image/heif'"
                  :id="'img' + index"
                  :src="image.url"
                  class="h-36 w-full object-cover rounded-lg"
                >
                  <div slot="error" class="image-slot">
                    <div class="h-36 w-20 flex items-center justify-center bg-gray-200 rounded-lg">
                      <i class="uil uil-image text-gray-400 text-4xl"></i>
                    </div>
                  </div>
                </el-image>
              </slot>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="text-center">No photos added.</p>
        </div>
      </div>
      <div
        class="text-center col-span-12 sm:col-span-3"
        v-if="allRequiredPhotosUploaded"
      >
        <span class="bg-green-500 rounded-full mt-2 mr-1">
          <i class="w-5 el-icon-check text-white text-sm"></i>
        </span>
        <span>All photos uploaded</span>
      </div>
    </template>

    <template v-else>
      <div
        class="fileContainer text-center bg-opacity-50 bg-white border-2 border-gray-400"
      >
        <div class="text-gray-700 text-sm py-1">Tap to Open Camera</div>
        <input
          ref="imageUploadInput"
          class="align-middle"
          type="file"
          multiple
          :capture="typeCapture"
          @change="handleAddNewImage"
        />
      </div>

      <div class="container mt-4 grid grid-cols-12 grid-flow-row gap-4">
        <div
          v-for="(image, index) of documents"
          :key="image.url"
          class="mb-2 col-span-12 sm:col-span-6 relative p-2"
        >
          <slot name="documents" :index="index" :image="image">
            <el-image
              v-if="image.url && image.fileType != 'image/heif'"
              :id="'img' + index"
              :src="image.url"
              class="h-36 w-full object-cover rounded-lg"
            >
              <div slot="error" class="image-slot">
                <div class="h-36 w-full flex items-center justify-center bg-gray-200 rounded-lg">
                  <i class="uil uil-image text-gray-400 text-4xl"></i>
                </div>
              </div>
            </el-image>
          </slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: [
    "documents",
    "vehicle",
    "requiredPhotos",
    "typeCapture",
    "allRequiredPhotosUploaded",
    "optionalPhotos",
    "specificPhotos",
    "isValidRequiredPhotos",
  ],
  methods: {
    handleAddNewSpecificPhotos(...args) {
      this.$emit("handleAddNewSpecificPhotos", ...args);
    },
    handleAddNewImage(...args) {
      this.$emit("handleAddNewImage", ...args);
    },
    handleOptionalImages(...args) {
      this.$emit("handleOptionalImages", ...args);
    },
    clearUploadInput(photoId) {
      let refName = photoId ? 'imageUploadInput' + photoId : 'imageOptionalUploadInput'
      const refElm = this.$refs[refName]
      if(Array.isArray(refElm)){
        refElm.forEach(ref=>ref.value = '')
      }else{
        refElm.value = ''
      }
    }
  }
};
</script>
